import type { CurrentUser } from "@/lib/auth";

export const DEFAULT_HOME_PAGE = "/";
const STORAGE_PREFIX = "eh-user-home-page:";
const REDIRECT_SESSION_PREFIX = "eh-home-redirected:";

function preferenceUserId(user: CurrentUser | null | undefined): string | null {
  if (!user) return null;
  const id = String(user.oid || user.sub || user.username || "").trim();
  return id || null;
}

export function userHomePageStorageKey(user: CurrentUser | null | undefined): string | null {
  const id = preferenceUserId(user);
  return id ? `${STORAGE_PREFIX}${id}` : null;
}

export function homePageRedirectSessionKey(user: CurrentUser | null | undefined): string | null {
  const id = preferenceUserId(user);
  return id ? `${REDIRECT_SESSION_PREFIX}${id}` : null;
}

/** Lokale Kopie, bis der Serverwert da ist, und Quelle für die einmalige Übernahme. */
export function readUserHomePage(user: CurrentUser | null | undefined): string {
  const key = userHomePageStorageKey(user);
  if (!key) return DEFAULT_HOME_PAGE;
  try {
    const value = localStorage.getItem(key);
    return value && value.startsWith("/") ? value : DEFAULT_HOME_PAGE;
  } catch {
    return DEFAULT_HOME_PAGE;
  }
}

export function writeUserHomePage(user: CurrentUser | null | undefined, href: string): void {
  const key = userHomePageStorageKey(user);
  if (!key) return;
  try {
    localStorage.setItem(key, href);
  } catch {
    /* ignore quota */
  }
}
